import { EmptyFormBox, FormBox } from 'common-front/src/designSystem/components/formBox';
import { Badge } from 'common/src/designSystem/components/badge';
import { Box } from 'common/src/designSystem/components/box';
import { Flex } from 'common/src/designSystem/components/flex';
import { useTranslate } from 'common/src/util/dependencies/dependencies';
import * as React from 'react';

const RoleFormBox = ({
    children,
    ...props
}: Omit<React.ComponentProps<typeof FormBox>, 'initialIsOpen'>) => (
    <FormBox css={{ 'legend + div': { minHeight: '32px' } }} initialIsOpen={true} {...props}>
        {children}
    </FormBox>
);

const UpcomingRoleFormBox = ({ title, subtitle }: { title: string; subtitle: string }) => {
    const translate = useTranslate();

    return (
        <EmptyFormBox>
            <Flex align="center" gap="4">
                <Flex css={{ flex: 1 }} direction="column" gap="1">
                    <Box color="gray900" fontSize="textMd" fontWeight="semiBold">
                        {title}
                    </Box>
                    <Box color="gray500">{subtitle}</Box>
                </Flex>
                <Badge color="white" css={{ textTransform: 'uppercase' }}>
                    {translate('bient_t_disponi_73022')}
                </Badge>
            </Flex>
        </EmptyFormBox>
    );
};

export { RoleFormBox as default, UpcomingRoleFormBox };
